import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';

export const usePerformanceDashboardEnabled = (): boolean => {
  return useFeatureIsOn(GROWTHBOOK_FEATURE_FLAGS.PERFORMANCE_DASHBOARD);
};
